export default function settingsReducer(settings, action) {
  switch (action.type) {
    case "SET_SETTINGS":
      return action.payload;

    case "UPDATE_SETTINGS":
      return { ...settings, ...action.payload };

    default:
      return settings;
  }
}
